import { Sort } from '@angular/material/sort';

export const defaultStatus = 'all';
export const defaultPageSizes: Array<number> = [5, 10, 20, 25];
export const orderStatusMap: Record<string, 'paid' | 'unpaid'> = {
  PAID: 'paid',
  RECEIVED: 'unpaid',
  CREDITED: 'unpaid',
  SOLD: 'unpaid',
  RETURNED: 'unpaid',
  UPDATED: 'unpaid',
  all: 'unpaid',
  paid: 'paid',
  unpaid: 'unpaid',
};

/* Column definitions */
/** Standard order when shipping, tax, and/or cost columns are shown */
export const monetaryColumnOrder = ['shipping', 'tax', 'cost'] as const;

export const paidColumns: string[] = [
  'vendor',
  'invoiceNumber',
  'datePaid',
  'shipping',
  'tax',
  'total',
  'options',
];

export const unpaidColumns: string[] = [
  'pay',
  'vendor',
  'status',
  'invoiceNumber',
  'invoiceDate',
  'shipping',
  'tax',
  'payments',
  'amountDue',
  'amountToPay',
  'options',
  'log',
];

export const allColumns: string[] = [
  'pay',
  'vendor',
  'status',
  'invoiceNumber',
  'invoiceDate',
  'shipping',
  'tax',
  'total',
  'link',
  'print',
];

export const defaultColumns = [
  'invoiceNumber',
  'date',
  'status',
  'shipping',
  'tax',
  'total',
  'action',
  'log',
  'fill',
  'expand',
];

export const vendorColumns = {
  distributor: ['vendor'],
};

export const colSortOrder = {
  select: 0,
  vendor: 1,
  status: 2,
  datePaid: 3,
  invoiceNumber: 4,
  date: 5,
  shipping: 6,
  tax: 7,
  total: 8,
  log: 9,
  fill: 10,
  expand: 11,
};

export const statusColumns = {
  paid: ['datePaid'],
  unpaid: ['select'],
};

/* Sort definitions */

export const defaultSort: Sort = { active: 'datePaid', direction: 'desc' };

export const sortConfig = {
  paid: {
    sortBy: 'datePaid',
    sortDir: 'desc',
  },
  unpaid: {
    sortBy: 'date',
    sortDir: 'desc',
  },
  all: {
    sortBy: 'date',
    sortDir: 'desc',
  },
};
